<template>
<el-dialog :close-on-click-modal="false" width="60%" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog" append-to-body>
    <div class="h-rowIn" >
        <div class="h-rowBox">
            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                <h1>历史报价信息</h1>
            </div>
            <el-table
                    ref="table1"
                    max-height="450"
                    :data="gyshistorydata"
					:border="true"
                    style="width: 100%">
                <el-table-column
                        prop="prodname"
                        label="产品型号"
                        min-width="150"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="proddes"
                        label="产品描述"
                        min-width="150"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="proddes"
                        label="供应商"
                        min-width="150"
                        :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{scope.row.supname+"["+scope.row.supid+"]"}}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="suptime"
                        label="报价时间"
                        min-width="150"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="supprice"
                        label="报价金额"
                        min-width="150"
                        :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column
                        prop="currency"
                        min-width="100"
                        :show-overflow-tooltip="true"
                        label="币种">
                    <template slot-scope="scope">
                        {{scope.row.currency | dictname('YLCurrency')}}
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</el-dialog>
</template>

<script>
    import ss from '../../api/SystemService'
    export default {
        data(){
          return {
              gyshistorydata:[],
          }
        },
        created(){
            this.gyshistorylist()
        },
        methods: {
            gyshistorylist() {
                ss.ProService.gysbjlistPage({
                    historyflag:1,
                    xmcode:this.xmcode,
                    proinfoid:this.proinfoid,
                    supid:this.gyscode,
                }).then(rd => {
                    this.gyshistorydata = rd.obj;
                });
            },
        },
        props: {
            proinfoid: {
                type: String,
            },
            gyscode:{
                type: String,
            },
            xmcode:{
                type: String,
            }
        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
</style>
